import {
    apiRequest,
    kriteriaSkpTunkinDetail,
    kriteriaSkpTunkinUpdate
} from "../../../../../services/adapters/kepegawaian/kriteriaSkpTunkinService"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", kriteriaSkpTunkinDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", kriteriaSkpTunkinUpdate, {
            body: query
        }, true)
    }
}

export default UpdateRepository